import { render } from "./UpdateCurrentRestaurant.vue?vue&type=template&id=177c19de&scoped=true"
import script from "./UpdateCurrentRestaurant.vue?vue&type=script&lang=js"
export * from "./UpdateCurrentRestaurant.vue?vue&type=script&lang=js"

import "./UpdateCurrentRestaurant.vue?vue&type=style&index=0&id=177c19de&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-177c19de"]])

export default __exports__